///<reference path="../../common/decorators.ts"/>
namespace TotalCore.Dashboard.Components {
    import Component = TotalCore.Common.Component;

    @Component('components.dashboard', {
        templateUrl: 'dashboard-translate-component-template',
        bindings: {}
    })
    class DashboardTranslateComponent {

    }
}